import React from 'react';

import AppPage from '../../components/AppPage';
import AdminPage from '../../components/AdminPage';
import StandaloneCartHistoryTable from './components/StandaloneCartHistoryTable';

function StandaloneCartHistory() {
      return (
            <AppPage title='Standalone Cart History'>
                  <StandaloneCartHistoryTable />
            </AppPage>
      );
}

export default function() {
      return (
            <AdminPage>
                  <StandaloneCartHistory />
            </AdminPage>
      )
}
